import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import CopyRight from "../../Assets/CopyRight";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Input from "../../components/Input";
import InputPhone from "../../components/InputPhone";
import { onSaveCustomer } from "../../config/config";
import { router } from "../../Constants";
import app from "../../firebase";
import { encrypt } from "../../utils/enkripsi";
import { showLog } from "../../utils/log";

function Home() {
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [captchaCalled, setCaptchaCalled] = React.useState(false);
  const [input, setInput] = React.useState({
    name: localStorage.getItem("register-nama")
      ? localStorage.getItem("register-nama")
      : "",
    phone1: localStorage.getItem("register-telp")
      ? localStorage.getItem("register-telp")
      : "",
    mode: "new",
  });

  function onSignInSubmit(e) {
    showLog("Register Masuk onSignInSubmit");
    e.preventDefault();
    onSignIn();
  }

  function configureCaptcha() {
    showLog("Register Masuk configureCaptcha");
    const auth = getAuth(app);
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
    }
    window.recaptchaVerifier = new RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: (response) => {
          setCaptchaCalled(true);
          onSignInSubmit();
        },
      },
      auth
    );
  }

  async function onSignIn(e) {
    showLog("Register Masuk onSignIn");
    setLoading(true);
    const phoneNumber = "+62" + input.phone1.replace(/ /g, "");
    const id = `${input.name.toLowerCase()}-${input.phone1}`;
    input["id"] = id;
    input["addresses"] = [];
    input["person_in_charge"] = "";
    input["top"] = "";
    input["ar_limit"] = "";
    input["active"] = "1";
    if (!input.phone1) {
      setLoading(false);
      addToast("Harap mengisi nomor telepon yang valid sebelum melanjutkan.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (!input.name) {
      setLoading(false);
      addToast("Harap mengisi nama sebelum melanjutkan.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (captchaCalled === false) {
      configureCaptcha();
    }
    const db = getFirestore(app);
    const docRef = doc(db, "users", phoneNumber);
    const docSnap = await getDoc(docRef);
    if (docSnap.data()) {
      setLoading(false);
      addToast(
        "Nomor telepon ini telah terdaftar sebelumnya. Silakan gunakan nomor lain atau coba login kembali.",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      return;
    }
    const appVerifier = window.recaptchaVerifier;
    const auth = getAuth(app);
    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then(async (confirmationResult) => {
        setLoading(false);
        localStorage.setItem(
          "detailDataCustomer",
          JSON.stringify(encrypt(input))
        );
        const result = await onSaveCustomer();
        if (result.status === "OK") {
          addToast(
            `Berhasil menyimpan customer dengan id ${input.id} ke database`,
            {
              appearance: "success",
              autoDismiss: true,
            }
          );
          window.confirmationResult = confirmationResult;
          navigate(`/${router}kode-otp-register`, { state: { detail: input } });
          localStorage.setItem("phoneNumberLogin", phoneNumber);
          localStorage.removeItem("register-nama");
          localStorage.removeItem("register-telp");
          setCaptchaCalled(false);
        } else {
          addToast(`Gagal menyimpan customer id ${input.id} ke database`, {
            appearance: "error",
            autoDismiss: true,
          });
          window.recaptchaVerifier.clear();
          setCaptchaCalled(false);
        }
        localStorage.setItem("saveCustomer", "true");
      })
      .catch((error) => {
        setLoading(false);
        if (error.code == "auth/invalid-phone-number") {
          addToast(
            "Nomor telepon yang Anda Masukkan tidak valid. Silakan periksa kembali dan coba lagi.",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        if (error.code == "auth/too-many-requests") {
          addToast(
            "Nomor telepon Anda telah melebihi batas percobaan. Silakan coba lagi dalam beberapa menit.",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        if (error.code == "auth/invalid-app-credential") {
          addToast(
            "Terjadi kesalahan verifikasi. Silakan muat ulang halaman dan coba lagi.",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        window.recaptchaVerifier.clear();
        setCaptchaCalled(false);
      });
  }

  return (
    <div>
      <div>
        <div
          style={{ marginTop: 10, marginLeft: 5, padding: 10 }}
          onClick={() => {
            navigate(`${router}/order`);
          }}
        >
          <BiArrowBack size={20} />
        </div>
      </div>
      <div style={{ margin: "20% 10px 10px 10px" }}>
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            padding: "30px 0px",
          }}
        >
          <div
            style={{ fontSize: 25, textAlign: "center" }}
            className="fonts700"
          >
            Daftar Sekarang dan Nikmati Kemudahan Memesan Makanan!
          </div>
        </div>
        <div id="sign-in-button"></div>
        <div style={{ paddingLeft: "20%", paddingRight: "20%" }}>
          <Input
            type="input"
            value={input.name}
            placeholder="Nama"
            label="Nama"
            onChange={(val) => {
              setInput((prevState) => ({
                ...prevState,
                name: val.target.value,
              }));
              localStorage.setItem("register-nama", val.target.value);
            }}
          />
          <Gap height={10} />
          <InputPhone
            placeholder="8123456789"
            type="input"
            value={input.phone1}
            label="Nomor Handphone"
            onChange={(val) => {
              setInput((prevState) => ({
                ...prevState,
                phone1: val,
              }));
              localStorage.setItem("register-telp", val);
            }}
          />
          <Gap height={20} />
          <Button
            onClick={(e) => {
              if (!loading) {
                onSignInSubmit(e);
              }
            }}
            loading={loading}
            backgroundColor="#5451D6"
            color="#fff"
          >
            Verifikasi Nomor Telepon
          </Button>
        </div>
        <div style={{ marginTop: "10%", textAlign: "center" }}>
          <CopyRight />
        </div>
      </div>
    </div>
  );
}

export default Home;
